/*
 * Copyright (c) 2024 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
 * LicenseRef-NvidiaProprietary
 *
 * NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
 * property and proprietary rights in and to this material, related
 * documentation and any modifications thereto. Any use, reproduction,
 * disclosure or distribution of this material and related documentation
 * without an express license agreement from NVIDIA CORPORATION or
 * its affiliates is strictly prohibited
 */
export const loadEnvVars = async () => {
    let res;
    const configUrl = 'airschipp-ui-config.json';

    // Default config
    window.airschipp = {
        api: 'https://air.nvidia.com/migrate/api',
        websocket: 'wss://air.nvidia.com',
        websocketPath: '/migrate/socket',
    };

    try {
        res = await fetch(configUrl);
        const data = await res.json();
        if (data) {
            Object.assign(window.airschipp, data);
        } else {
            throw Error;
        }
    } catch {
        console.warn(`Unable to parse config from ${configUrl}. Using defaults.`);
    }
    return res;
};

export default {
    loadEnvVars,
};
